<script setup lang="ts">
import { ref } from 'vue'
import type { ButtonOption } from '@/types'

defineProps<{
  options: ButtonOption[]
}>()

const emit = defineEmits<{
  (e: 'submit', value: string | number | boolean): void
}>()

const selectedIndex = ref<number | null>(null)

function handleSelect(option: ButtonOption, index: number) {
  selectedIndex.value = index

  // Brief visual feedback before submitting
  setTimeout(() => {
    emit('submit', option.value)
  }, 200)
}
</script>

<template>
  <div class="w-full animate-slide-up">
    <div class="space-y-2 px-1">
      <button
        v-for="(option, index) in options"
        :key="index"
        @click="handleSelect(option, index)"
        :class="[
          'w-full py-4 px-5 rounded-2xl text-left font-medium transition-all duration-200',
          'border-2 active:scale-[0.98]',
          selectedIndex === index
            ? 'border-primary bg-primary/10 text-primary'
            : 'border-gray-200 bg-white text-gray-800 hover:border-primary/50'
        ]"
      >
        <div class="flex items-center justify-between">
          <span>{{ option.text }}</span>
          <div
            v-if="selectedIndex === index"
            class="w-6 h-6 rounded-full bg-primary flex items-center justify-center"
          >
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>
